/*
 *
 * PasswordRecovery constants
 *
 */

export const RECOVER_WATCHER = "app/ForgottenPassword/RECOVER_WATCHER"
export const RECOVER_SUCCESS = "app/ForgottenPassword/RECOVER_SUCCESS"
export const RECOVER_FAILED = "app/ForgottenPassword/RECOVER_FAILED"
export const RESET_RECOVER = "app/ForgottenPassword/RESET_RECOVER"
